import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {AnalogOutStatus} from "./analogoutStatus";
import {UrlBuilder} from "../url-builder/url.builder";

@Injectable({
  providedIn: 'root'
})
export class AnalogOutStatusDataservice {

  private uiUrl: string = "";
  private url: UrlBuilder;

  constructor(private http: HttpClient) {
    this.url = new UrlBuilder();
  }


  GetData(): Observable<AnalogOutStatus> {
    this.uiUrl = this.url.GetAnalogOutStatusUrl();
    console.log('FILE: ' + this.uiUrl);
    return this.http.get<AnalogOutStatus>(this.uiUrl);
  }

}


